// removed by extract-text-webpack-plugin
module.exports = {"Text":"purify_Text__Text___2s2Ds","center":"purify_Text__center___nqlwT","invert":"purify_Text__invert___2C1CK","shrink":"purify_Text__shrink___nwkLH","reRenderText":"purify_Text__reRenderText___KPk6-","focused":"purify_Text__focused___3Mgqd","focus":"purify_Text__focus___1smPW","invisible":"purify_Text__invisible___1Juru","back":"purify_Text__back___uu9HN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Text/Text.scss
// module id = 245
// module chunks = 0